export default __webpack_public_path__ + "static/media/Unerring Crossfire.dcac7009.jpg";